import { render } from "./VCheckbox.vue?vue&type=template&id=69e61895"
import script from "./VCheckbox.vue?vue&type=script&lang=js"
export * from "./VCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__